import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import { pushWishlistEvent } from "../../../../../../data-layer/data-layer/wishlist.js";
import { useRemoveFromShoppinglist } from "../../../../../../hooks/hooks/use-remove-from-shopping-list.js";
import { useWishlistAuthState } from "../../../../../../hooks/hooks/use-wishlist-auth-state.js";
import AnonymousWishlist from "./AnonymousWishlistOverview.js";
import UserWishlistOverview from "./UserWishlistOverview.js";
const WishlistContainer = () => {
  const { isAuthLoading, isUserLoggedIn } = useWishlistAuthState();
  const { isMyAccountEnabled } = useFeatureToggles();
  const { clearWishlist } = useWishlistId();
  const {
    loading: isUpdateLoading,
    removeFromShoppinglist,
    error
  } = useRemoveFromShoppinglist({
    onCompleted: (data) => {
      if (data.removeFromShoppinglist.__typename === "RemoveFromShoppinglistSuccessResponse") {
        toast.success("account.wishlist.remove.success");
        if (data.removeFromShoppinglist.__typename === "RemoveFromShoppinglistSuccessResponse" && !data.removeFromShoppinglist.result?.items.length) {
          clearWishlist();
        }
      }
    },
    onError: () => {
      toast.failed("account.wishlist.remove.error");
    }
  });
  const handlePushWishlistEvent = React.useCallback(
    (sku) => {
      pushWishlistEvent({
        siteFeature: "my_account",
        interactionType: "wishlist_remove_item_click",
        messageType: error ? "error" : "item_removed",
        item: {
          sku
        }
      });
    },
    [error]
  );
  const onUpdateWishList = (sku, wishlistId) => {
    handlePushWishlistEvent(sku);
    removeFromShoppinglist([sku], wishlistId);
  };
  return !isAuthLoading && isUserLoggedIn ? /* @__PURE__ */ React.createElement(UserWishlistOverview, { isUpdateLoading, onUpdateWishList }) : /* @__PURE__ */ React.createElement(
    AnonymousWishlist,
    {
      isMyAccountEnabled,
      isUpdateLoading,
      isAuthLoading,
      onUpdateWishList
    }
  );
};
export {
  WishlistContainer as default
};
//# sourceMappingURL=WishlistOverviewContainer.js.map
